module.exports = __webpack_public_path__ + "media/images/new_landing/logos/oralb-0d571139239a130bcd1fd4ab7274fad7.png";